import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { PersonalSiteComponent } from './personal-site.component';
import { VeaPersonalSiteComponent } from './vea-personal-site/vea-personal-site.component';
import { FranchisePartnerPersonalSiteComponent } from './franchise-partner-personal-site/franchise-partner-personal-site.component';
import { PersonalSiteRoutingModule } from './personal-site-routing.module';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [PersonalSiteComponent, VeaPersonalSiteComponent, FranchisePartnerPersonalSiteComponent],
  imports: [CommonModule, SharedModule, PersonalSiteRoutingModule, RecaptchaModule, RecaptchaFormsModule],
})
export class PersonalSiteModule {}
